/* eslint-disable @nx/enforce-module-boundaries */
import { useTranslation } from '@axo/shared/i18n';
import { Stack } from '@axo/ui-core/components/layout/item';
import { Modal } from '@axo/ui-core/components/Modal';
import { Spinner } from '@axo/ui-core/components/Spinner';
import { Text } from '@axo/ui-core/components/typography';
import { useEffect, useState } from 'react';
import { useAxoFormContext } from '../../../../../../context/AxoForm/AxoForm';
import type { DenmarkFormData } from '../../../FormData.dk.types';

export const MitIDSuccess = () => {
  const { t } = useTranslation();
  const { onSubmit } = useAxoFormContext<DenmarkFormData>();

  const [timer, setTimer] = useState(5);

  useEffect(() => {
    if (timer === 0) {
      onSubmit({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timer]);

  useEffect(() => {
    const interval = setInterval(
      () => setTimer((state) => (state > 0 ? state - 1 : 0)),
      1000
    );

    return () => clearInterval(interval);
  }, []);

  return (
    <Modal open={true}>
      <Modal.Header feedbackState="success">
        <Text size="l">{t('MitID.data_shared')}</Text>
      </Modal.Header>
      <Stack gap="2xl">
        <Spinner size="l" />

        <Text size="xs">{t('MitID.redirect', { time: timer })}</Text>
      </Stack>
    </Modal>
  );
};
